import React from 'react';
import PropTypes from 'prop-types';
import { Container, Title } from './styles';

export const SendCurriculum = ({ primaryColor, params }) => {
  return (
    <Container id="sendCurriculum">
      <Title>Não encontrou a vaga que queria?</Title>
      <a href={`${process.env.REACT_APP_TALENT_URL}/${params}/signup`}>
        Faça parte do nosso Banco de Talentos
      </a>
    </Container>
  );
};

SendCurriculum.propType = {
  primaryColor: PropTypes.string.isRequired,
  link: PropTypes.string.isRequired,
};
